import { render, staticRenderFns } from "./uni-popup.vue?vue&type=template&id=26d26e5b"
import script from "./uni-popup.vue?vue&type=script&lang=js"
export * from "./uni-popup.vue?vue&type=script&lang=js"
import style0 from "./uni-popup.vue?vue&type=style&index=0&id=26d26e5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports